<template>
  <button
    type="button"
    :class="['btn btn-sm ladda-button ', btnClass ? btnClass: '' ]"
    data-style="expand-left"
    :data-loading="loading"
    :disabled="loading || disabled"
  >
    <span
      class="me-1"
      v-if="icon && !loading"
      v-html="icon"
    />
    <span v-if="loading" class="me-1">
      <i class="fa-solid fa-spinner fa-spin" />
    </span>
    {{ text ? $t(text) : $t('ladda') }}
    <span v-if="count">
      ({{ count }})
    </span>
    <slot name="append-text" />
  </button>
</template>

<script>
  export default {
    name: 'Ladda',
    props: ['loading', 'text', 'icon', 'btnClass', 'type','disabled','count']
  }
</script>

